import { Injectable } from "@angular/core";
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { filter, switchMap, take, timeout } from "rxjs/operators";

import { AuthenticationService } from "@indusoft/authenticator";
import { ConfigurationHttpService } from "../../common/services/configuration.service";

/**
 * Притормаживает определенные запросы до получения аас токена
 */
@Injectable()
export class AasGateInterceptor implements HttpInterceptor {
    constructor(
        private authService: AuthenticationService,
        private configurationHttpService: ConfigurationHttpService
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const aasEnabled = this.configurationHttpService.isAasEnabled;

        if (!aasEnabled) {
            return next.handle(req);
        }

        const whitelist = [
            '/config',
            '/settings'
        ];

        const isWhitelisted = whitelist.some(path => req.url.toLowerCase().includes(path));

        if (isWhitelisted) {
            return next.handle(req);
        }

        const tokenNow = this.authService.accessToken;
        if (tokenNow) {
            return next.handle(req.clone({ setHeaders: { Authorization: this.normalize(tokenNow) } }));
        }

        return this.authService.accessToken$.pipe(
            filter((t): t is string => typeof t === "string" && t.length > 0),
            take(1),
            timeout({ first: 8000 }),
            switchMap(t => next.handle(req.clone({ setHeaders: { Authorization: this.normalize(t) } })))
        );
    }

    private normalize(t: string) {
        return t.startsWith("Bearer ") ? t : `Bearer ${t}`;
    }
}